import { graphql, type GraphQLTaggedNode } from 'react-relay';

export const ViewPageConversationContentPermissionFragment: GraphQLTaggedNode = graphql`
	fragment ViewPageConversation_contentPermission on Content {
		id
		type
		operations {
			operation
			targetType
		}
		space {
			id
			operations {
				operation
				targetType
			}
		}
		history {
			createdBy {
				__typename
				... on KnownUser {
					accountId
				}
			}
		}
	}
`;

export const ViewPageConversationCurrentUserFragment: GraphQLTaggedNode = graphql`
	fragment ViewPageConversation_currentUser on Query {
		user: confluence_atlassianUser(current: true) {
			id
			displayName
			photos {
				isPrimary
				value
			}
		}
	}
`;

export const ViewPageConversationCommentReactionsFragment: GraphQLTaggedNode = graphql`
	fragment ViewPageConversation_commentReactions on Comment {
		reactionsSummary(pageId: $pageId, contentType: "page", childType: "comment")
			@include(if: $includeCommentReactions) {
			ari
			containerAri
			reactionsCount
			reactionsSummaryForEmoji {
				id
				count
				emojiId
				reacted
			}
		}
	}
`;

export const ViewPageConversationReplyFragment: GraphQLTaggedNode = graphql`
	fragment ViewPageConversation_reply on Comment {
		id
		author {
			__typename
			displayName
			permissionType
			... on KnownUser {
				accountId
			}
			profilePicture {
				path
			}
		}
		body(representation: ATLAS_DOC_FORMAT) {
			value
		}
		contentStatus
		createdAt {
			value
		}
		createdAtNonLocalized
		links {
			editui
			webui
		}
		location {
			__typename
			type
			... on FooterComment {
				commentResolveProperties {
					resolved
					resolvedFriendlyDate
					resolvedTime
					resolvedUser
				}
			}
			... on InlineComment {
				inlineMarkerRef
				inlineResolveProperties {
					isDangling
					resolved
					resolvedFriendlyDate
					resolvedTime
					resolvedUser
				}
				inlineText
			}
		}
		parentId
		permissions {
			isEditable
			isRemovable
			isResolvable
		}
		...ViewPageConversation_commentReactions @relay(mask: false)
		version {
			by {
				__typename
				displayName
			}
			number
			when
		}
	}
`;
